var exports = {
  "h": "xa15a2ab7--e84f44--description",
};

module.exports = exports;
